import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';

// components
import { FormGroup, Input, Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Select from 'react-select'
import MaterialTable from 'material-table';

// style
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

// helpers
import { showMessage } from "../../../helpers/message";
import { transformValueFloattoMoney } from '../../../helpers/formats';

// api
import penalidade_api from "../../../api/penalidade_api.js";
import analiseboletim_api from "../../../api/analiseboletim_api.js";
import ModalPesquisaReincidencias from './ModalPesquisaReincidencias';

export default function AnaliseGestor({ boletimVistoria, setshowLoading, handleReturn }) {

    const { register, getValues, clearErrors, setValue } = useForm({ mode: "onBlur" });

    // Tipo de Penalidade
    const options_tipoPenalidade = [
        { label: "Advertência", value: "Advertência" },
        { label: "Multa", value: "Multa" }
    ];
    const [tipoPenalidade, set_tipoPenalidade] = useState(null);
    const handleChangeTipoPenalidade = (value) => {
        set_tipoPenalidade(value);
        clearErrors("tipoPenalidade");
        setValue("tipoPenalidade", value, true);
    }

    // Penalidades
    const [options_penalidades, set_options_penalidades] = useState([]);
    const loadOptionsPenalidades = () => {
        penalidade_api.GetPenalidadesAtivasByFormularioConcessionaria(boletimVistoria.concessionaria_Id, boletimVistoria.formularioVistoria_Id).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_options_penalidades(result.data);
            }
        });
    }

    const [penalidades, set_penalidades] = useState([]);
    const handleChangePenalidades = (value) => {
        let _penalidades = [];
        if (value)
            value.map(m => {
                _penalidades.push({
                    penalidade_Id: m.penalidade_Id,
                    descricao: m.descricao,
                    advertencia: m.penalidadeConcessionaria[0].advertencia,
                    valor: m.penalidadeConcessionaria[0].valor,
                    valorReincidencia: m.penalidadeConcessionaria[0].valorReincidencia,
                    valorSegundaReincidencia: m.penalidadeConcessionaria[0].valorSegundaReincidencia
                });
            });
        set_penalidades(_penalidades);
    }
    const handleChangeValorPenalidade = (penalidade_Id, value) => {
        let _penalidades = [];
        penalidades.map(m => {
            if (m.penalidade_Id == penalidade_Id)
                m.valorPenalidade = value

            _penalidades.push(m);
        })
        set_penalidades(_penalidades);
    }

    const [itemPesquisaReincidencias, set_itemPesquisaReincidencias] = useState(null);
    const handleViewReincidencias = (rowData) => {
        set_itemPesquisaReincidencias(rowData);
    }
        
    const handleExecutarAcao = (acao) => {
        if (acao == "Efetuar Enquadramento" && penalidades.length == 0) {
            showMessage("Aviso", "Informe as penalidades", 'error', null);
            return;
        }

        if (tipoPenalidade == "Multa" && penalidades.filter(f => f.valorPenalidade == null || f.valorPenalidade == "").length > 0) {
            showMessage("Aviso", "Informe o valor da multa em todas as penalidades", 'error', null);
            return;
        }

        let _penalidadesaplicadas = [];
        penalidades.map(m => {
            _penalidadesaplicadas.push({
                penalidade_Id: m.penalidade_Id,
                tipoPenalidade: tipoPenalidade,
                valorPenalidade: m.valorPenalidade,
                advertencia: tipoPenalidade == "Advertência" ? m.advertencia : ""
            });
        })

        let data = getValues();

        let json_submit = {
            boletimVistoria_Id: boletimVistoria.boletimVistoria_Id,
            situacaoAnalise: boletimVistoria.situacaoAnalise,
            acao: acao,
            observacao: data.observacao,
            penalidades: _penalidadesaplicadas
        }

        setshowLoading(true);
        analiseboletim_api.post(json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Operação executada com sucesso!", 'success', function(){ handleReturn(true)});
            }
        })

    }

    useEffect(() => {
        loadOptionsPenalidades();
    }, []);

    return (
        <>
            <h5 className="subtitleCardInfo">Enquadramento</h5>
            <Row className="mb-4">
                <Col lg="12" md="12" sm="12">
                    <FormGroup>
                        <label className="form-control-label">Observações</label>
                        <Input className="form-control"
                            autocomplete="off"
                            type="text"
                            name="observacao"
                            innerRef={register({ required: false })}
                        />
                    </FormGroup>
                </Col>
                <Col lg="3" md="4" sm="12">
                    <FormGroup>
                        <label className="form-control-label">Tipo de Penalidade</label>
                        <Select
                            name="tipoPenalidade"
                            options={options_tipoPenalidade}
                            getOptionLabel={o => o.label}
                            getOptionValue={o => o.value}
                            value={options_tipoPenalidade.filter(f => f.value == tipoPenalidade)}
                            onChange={(e) => handleChangeTipoPenalidade(e.value)}
                            classNamePrefix="select"
                            placeholder="[ Selecione ]"
                            ref={e => register(
                                { name: "tipoPenalidade" },
                                { required: false })
                            }
                        />
                    </FormGroup>
                </Col>
                <Col lg="9" md="8" sm="12">
                    <FormGroup>
                        <label className="form-control-label">Lista de Penalidades</label>
                        <Select
                            name="penalidades"
                            options={options_penalidades}
                            getOptionLabel={o => o.descricao}
                            getOptionValue={o => o.penalidade_Id}
                            onChange={(o) => handleChangePenalidades(o)}
                            value={options_penalidades.filter(({ penalidade_Id }) => penalidades.filter(f => f.penalidade_Id == penalidade_Id).length > 0)}
                            classNamePrefix="select"
                            placeholder="[ Selecione ]"
                            isMulti={true}
                            ref={e => register(
                                { name: "penalidades" },
                                { required: false })
                            }
                        />
                    </FormGroup>
                </Col>
                <Col lg="12" md="12" sm="12">
                    <MaterialTable style={{ minHeight: "auto" }}
                        title=""
                        columns={[
                            { title: 'Descrição', field: 'descricao' },
                            { title: 'Advertência', field: 'advertencia' },
                            { title: 'Valor', render: (rowData) => transformValueFloattoMoney(rowData.valor) },
                            { title: 'Valor Primeira Reincidência', render: (rowData) => transformValueFloattoMoney(rowData.valorReincidencia) },
                            { title: 'Valor Segunda Reincidência', render: (rowData) => transformValueFloattoMoney(rowData.valorSegundaReincidencia) },
                            {
                                title: 'Valor Aplicado', render: rowData =>
                                    <Input className="form-control"
                                        autocomplete="off"
                                        type="number"
                                        name="valorPenalidade"
                                        readOnly={tipoPenalidade == "Advertência"}
                                        onChange={(e) => handleChangeValorPenalidade(rowData.penalidade_Id, e.target.value)}
                                        innerRef={register({ required: false })}
                                    />
                            },
                        ]}
                        data={penalidades}
                        isLoading={false}
                        options={{
                            ...table_style,
                            filtering: false,
                            exportButton: true
                        }}
                        actions={[
                            {
                                icon: 'search',
                                tooltip: 'Visualizar Reincidências',
                                onClick: (event, rowData) => handleViewReincidencias(rowData)
                            }
                        ]}
                        localization={table_translate}
                    />
                </Col>
                <Col lg="12" md="12" sm="12">
                    <Button color="warning" onClick={() => handleExecutarAcao("Efetuar Enquadramento")}>Efetuar Enquadramento</Button>
                    <Button color="success" onClick={() => handleExecutarAcao("Arquivar")}>Arquivar</Button>
                </Col>
            </Row>
            <ModalPesquisaReincidencias 
                boletimVistoria={boletimVistoria}                
                itemPesquisaReincidencias={itemPesquisaReincidencias}
                handleCloseModalReincidencias={() => set_itemPesquisaReincidencias(null)}
            ></ModalPesquisaReincidencias>
        </>
    );
}
